var _path, _path2, _path3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchBigActiveDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 152,
    viewBox: "0 0 144 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1423 54.6573C15.1423 29.5896 35.5896 9.14232 60.6573 9.14232C65.4742 9.14232 70.0945 9.92875 74.4199 11.305L81.7927 4.3254C75.3046 1.57287 68.1284 0 60.6573 0C30.5761 0 6 24.5761 6 54.6573C6 61.0471 7.08135 67.142 9.14575 72.8436L16.5186 65.864C15.6338 62.325 15.1423 58.5895 15.1423 54.6573Z",
    fill: "#4D8FF1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6566 100.27C39.5211 100.27 21.5314 85.6228 16.5179 65.9619L9.14502 72.9415C16.7145 94.1753 36.9652 109.412 60.6566 109.412C66.1616 109.412 71.5684 108.528 76.6802 107.053L65.8667 100.074C64.1955 100.074 62.426 100.27 60.6566 100.27Z",
    fill: "#FF542E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.314 54.6571C115.314 32.0471 101.453 12.5828 81.7925 4.3252L74.4197 11.3048C92.8026 17.2031 106.172 34.4064 106.172 54.6571C106.172 77.9552 88.4772 97.3212 65.8672 99.8771L76.6807 106.857C98.9958 100.074 115.314 79.2332 115.314 54.6571Z",
    fill: "#4E55A2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M128.304 121.526L94.2673 86.9367C102.371 78.7011 107.234 67.1712 107.234 54.5433C107.234 28.7384 86.7035 7.87485 61.3106 7.87485C35.3775 7.32581 14.8472 28.1893 14.8472 53.9942C14.8472 79.7991 35.3775 100.663 60.7704 100.663C69.955 100.663 78.5994 97.9175 85.6229 92.9761L120.2 128.115C121.281 129.213 122.902 129.762 123.982 129.762C125.063 129.762 126.684 129.213 127.764 128.115C130.466 127.017 130.466 123.722 128.304 121.526ZM25.6526 53.9942C25.6526 34.2288 41.3205 18.3066 60.7704 18.3066C80.2202 18.3066 95.8881 34.2288 95.8881 53.9942C95.8881 73.7597 80.2202 89.6819 60.7704 89.6819C41.3205 90.2309 25.6526 74.3087 25.6526 53.9942Z",
    fill: "#4A4A4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0.847168,
    y: 1.86426,
    width: 143.016,
    height: 149.898,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchBigActiveDark);
export default __webpack_public_path__ + "static/media/Search_big_Active_Dark.e89f19c2c39b58c7d25dddfb79942bcd.svg";
export { ForwardRef as ReactComponent };